<template>
  <div id="app">
    <div class="nav-main" v-show="hideHeader">
      <div class="navbar-area">
        <div class="container">
          <div class="mobile-nav">
            <div class="mobile-nav-category">
              <a href="#" class="mobile-nav-category-btn">
                <i class="flaticon-menu"></i>
              </a>
            </div>
            <a class="mobile-brand d-lg-none">
              <img
                src="../../static/img/资源 1.png"
                style="width: 150px"
                @click="navto('/', true)"
              />
            </a>
            <div class="navbar-option">
              <div class="navbar-option-item d-none mobile-nav-sidebar">
                <img
                  src="../../static/img/5.png"
                  class="select"
                  v-show="hideSearch"
                />
                <img
                  src="../../static/img/9.png"
                  class="language"
                  v-if="!languagehover && language == 'en'"
                  @mouseenter="languagehover = true"
                />
                <img
                  src="../../static/img/7.png"
                  class="language"
                  v-if="languagehover && language == 'en'"
                  @mouseleave="languagehover = false"
                  @click="handlelanguage('zh')"
                />
                <img
                  src="../../static/img/8.png"
                  class="language"
                  v-if="!languagehover && language == 'zh'"
                  @mouseenter="languagehover = true"
                />
                <img
                  src="../../static/img/6.png"
                  class="language"
                  v-if="languagehover && language == 'zh'"
                  @mouseleave="languagehover = false"
                  @click="handlelanguage('en')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="main-nav" @mouseleave="showMenu(0)">
          <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
              <div class="navbar-category">
                <img
                  src="../../static/img/资源 1.png"
                  @click="navto('/', true)"
                />
              </div>
              <div
                class="collapse navbar-collapse mean-menu"
                id="navbarSupportedContent"
              >
                <ul class="nav navbar-nav mx-auto">
                  <!-- <el-popover
                    placement="top"
                    title=""
                    width="200"
                    trigger="hover"
                    ref="empPopover"
                    content=""
                    popper-class="my-popover"
                    :close-delay="0"
                    v-model="menushow1"


                  >
                    <div class="dropdown-div"  @mouseenter="showMenu(1)" @mouseleave="showMenu(0)">
                      <div class="title" @click="navtoLazy('/Aboutus?type=2')">
                        {{ language == "zh" ? "关于我们" : "About us" }}
                      </div>
                      <div class="title" @click="navtoLazy('/Aboutus?type=3')">
                        {{ language == "zh" ? "经营理念" : "Core Value" }}
                      </div>
                      <div class="title" @click="navtoLazy('/Aboutus?type=4')">
                        {{ language == "zh" ? "资质荣誉" : "Qualifications" }}
                      </div>
                      <div class="title" @click="navtoLazy('/Aboutus?type=5')">
                        {{ language == "zh" ? "设备环境" : "Plant&Facility" }}
                      </div>
                    </div>
                    <li class="nav-item pc_nav" slot="reference" @mouseenter="showMenu(1)" >
                      <a
                        @click="navto('/Aboutus')"
                        :class="
                          $route.path.indexOf('Aboutus') >= 0 ? 'active' : ''
                        "
                        class="nav-link"
                        ><span v-if="language == 'en'">About</span
                        ><span v-else>公司简介</span></a
                      >
                    </li>
                  </el-popover> -->
                  <li class="nav-item pc_nav" @mouseenter="showMenu(1)">
                    <a
                      @click="navto('/Aboutus')"
                      :class="
                        $route.path.indexOf('Aboutus') >= 0 ? 'active' : ''
                      "
                      class="nav-link"
                    ><span v-if="language == 'en'">About</span
                    ><span v-else>公司简介</span></a
                    >
                  </li>
                  <li class="nav-item pc_nav">
                    <a
                      @click="navto('/Product')"
                      :class="
                        $route.path.indexOf('Product') >= 0 ? 'active' : ''
                      "
                      class="nav-link"
                      @mouseenter="showMenu(2)"
                    ><span v-if="language == 'en'">Products</span
                    ><span v-else>产品中心</span></a
                    >
                  </li>
                  <li class="nav-item pc_nav" @mouseenter="showMenu(3)">
                    <a
                      @click="navto('/Technical')"
                      :class="
                        $route.path.indexOf('Technical') >= 0 ? 'active' : ''
                      "
                      class="nav-link"
                    ><span v-if="language == 'en'">Support</span
                    ><span v-else>技术支持</span></a
                    >
                  </li>
                  <li class="nav-item pc_nav" @mouseenter="showMenu(4)">
                    <a
                      @click="navto('/News')"
                      :class="$route.path.indexOf('News') >= 0 ? 'active' : ''"
                      class="nav-link"
                    ><span v-if="language == 'en'">News</span
                    ><span v-else>新闻动态</span></a
                    >
                  </li>
                  <li class="nav-item pc_nav" @mouseenter="showMenu(5)">
                    <a
                      @click="navto('/CallUs')"
                      :class="
                        $route.path.indexOf('CallUs') >= 0 ? 'active' : ''
                      "
                      class="nav-link"
                    ><span v-if="language == 'en'">Contact</span
                    ><span v-else>联系我们</span></a
                    >
                  </li>
                  <li class="nav-item phone_nav" @mouseenter="showMenu(1)">
                    <a
                      @click="navto('/Aboutus')"
                      href="/Aboutus"
                      :class="
                        $route.path.indexOf('Aboutus') >= 0 ? 'active' : ''
                      "
                      class="nav-link phone_a"
                    ><span v-if="language == 'en'">About</span
                    ><span v-else>公司简介</span></a
                    >
                  </li>
                  <li class="nav-item phone_nav">
                    <a
                      @click="navto('/Product')"
                      href="/Product"
                      :class="
                        $route.path.indexOf('Product') >= 0 ? 'active' : ''
                      "
                      class="nav-link phone_a"
                      @mouseenter="showMenu(2)"
                    ><span v-if="language == 'en'">Products</span
                    ><span v-else>产品中心</span></a
                    >
                  </li>
                  <li class="nav-item phone_nav" @mouseenter="showMenu(3)">
                    <a
                      @click="navto('/Technical')"
                      href="/Technical"
                      :class="
                        $route.path.indexOf('Technical') >= 0 ? 'active' : ''
                      "
                      class="nav-link phone_a"
                    ><span v-if="language == 'en'">Support</span
                    ><span v-else>技术支持</span></a
                    >
                  </li>
                  <li class="nav-item phone_nav" @mouseenter="showMenu(4)">
                    <a
                      @click="navto('/News')"
                      href="/News"
                      :class="$route.path.indexOf('News') >= 0 ? 'active' : ''"
                      class="nav-link phone_a"
                    ><span v-if="language == 'en'">News</span
                    ><span v-else>新闻动态</span></a
                    >
                  </li>
                  <li class="nav-item phone_nav" @mouseenter="showMenu(5)">
                    <a
                      @click="navto('/CallUs')"
                      href="/CallUs"
                      :class="
                        $route.path.indexOf('CallUs') >= 0 ? 'active' : ''
                      "
                      class="nav-link phone_a"
                    ><span v-if="language == 'en'">Contact</span
                    ><span v-else>联系我们</span></a
                    >
                  </li>
                </ul>
              </div>
              <div class="navbar-option">
                <div
                  class="
                    navbar-option-item navbar-language
                    dropdown
                    language-option
                  "
                >
                  <img
                    src="../../static/img/5.png"
                    class="select"
                    v-show="hideSearch"
                    @click="navto('/Product?isshow=true')"
                  />
                  <img
                    src="../../static/img/9.png"
                    class="language"
                    v-if="!languagehover && language == 'en'"
                    @mouseenter="languagehover = true"
                  />
                  <img
                    src="../../static/img/7.png"
                    class="language"
                    v-if="languagehover && language == 'en'"
                    @mouseleave="languagehover = false"
                    @click="handlelanguage('zh')"
                  />
                  <img
                    src="../../static/img/8.png"
                    class="language"
                    v-if="!languagehover && language == 'zh'"
                    @mouseenter="languagehover = true"
                  />
                  <img
                    src="../../static/img/6.png"
                    class="language"
                    v-if="languagehover && language == 'zh'"
                    @mouseleave="languagehover = false"
                    @click="handlelanguage('en')"
                  />
                </div>
              </div>
            </nav>
          </div>
        </div>
        <div
          class="product-menu"
          :class="menushow1 ? 'product-menu-show' : 'product-menu-hide'"
          @mouseenter="menushow1 = true"
          @mouseleave="menushow1 = false"
        >
          <div class="top-row top-row-center">
            <div class="top-item">
              <div class="title" @click="navto('/Aboutus?type=2')">{{
                  language == "zh" ? "关于我们" : "About us"
                }}
              </div>
            </div>
            <div class="top-item">
              <div class="title" @click="navto('/Aboutus?type=3')">{{
                  language == "zh" ? "经营理念" : "Core Value"
                }}
              </div>
            </div>
            <div class="top-item">
              <div class="title" @click="navto('/Aboutus?type=4')">{{
                  language == "zh" ? "资质荣誉" : "Qualifications"
                }}
              </div>
            </div>
            <div class="top-item">
              <div class="title" @click="navto('/Aboutus?type=5')">{{
                  language == "zh" ? "设备环境" : "Plant&Facility"
                }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="product-menu"
          :class="menushow2 ? 'product-menu-show' : 'product-menu-hide'"
          @mouseenter="menushow2 = true"
          @mouseleave="menushow2 = false"
        >
          <div class="top-row">
            <div v-for="(item, i) in menu" class="top-item" :key="i">
              <div
                class="title"
                :class="item.disabled ? 'title-disabled' : 'title'"
                @click="
                  item.disabled
                    ? ''
                    : navto('/ProductDetail?type1=' + item.value)
                "
              >
                {{ language == "zh" ? item.label : item.labelEn }}
              </div>
              <div class="heng"></div>
              <div class="child">
                <div v-for="(items, ins) in item.children" :key="ins">
                  <p
                    :class="
                      items.disabled ? 'child-title-disabled' : 'child-title'
                    "
                    class="child-title"
                    @click="
                      items.disabled
                        ? ''
                        : navto(
                            '/ProductDetail?type1=' +
                              item.value +
                              '&type2=' +
                              items.value
                          )
                    "
                  >
                    {{ language == "zh" ? items.label : items.labelEn }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="product-menu"
          :class="menushow3 ? 'product-menu-show' : 'product-menu-hide'"
          @mouseenter="menushow3 = true"
          @mouseleave="menushow3 = false"
        >
          <div class="top-row">
            <div v-for="(item, i) in jszc" class="top-item" :key="i">
              <div
                class="title"
                @click="
                  navtoWithType('/Technical', 'technical_menu_position', i)
                "
              >
                {{ language == "zh" ? item.type : item.typeEn }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          class="product-menu"
          :class="menushow4 ? 'product-menu-show' : 'product-menu-hide'"
          @mouseenter="menushow4 = true"
          @mouseleave="menushow4 = false"
        >
          <div class="top-row">
            <div v-for="(item, i) in xwdt" class="top-item" :key="i">
              <div
                class="title"
                @click="navtoWithType('/News?', 'news_menu_positon', i)"
              >
                {{ language == "zh" ? item.type : item.typeEn }}
              </div>
            </div>
          </div>
        </div> -->

        <div
          class="product-menu"
          :class="menushow5 ? 'product-menu-show' : 'product-menu-hide'"
          @mouseenter="menushow5 = true"
          @mouseleave="menushow5 = false"
        >
          <div class="top-row">
            <div class="top-item">
              <div
                class="title"
                @click="navtoWithType('/CallUs', 'callus_menu_position', 0)"
              >
                {{ language == "zh" ? "联系方式" : "Contact Info" }}
              </div>
            </div>
            <div class="top-item">
              <div
                class="title"
                @click="navtoWithType('/CallUs', 'callus_menu_position', 1)"
              >
                {{ language == "zh" ? "招聘信息" : "Recruitment" }}
              </div>
            </div>
            <div v-for="(item, i) in lxwm" class="top-item" :key="i">
              <div
                class="title"
                @click="navtoWithType('/CallUs', 'callus_menu_position', i + 2)"
              >
                {{ language == "zh" ? item.type : item.typeEn }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <keep-alive>
      <router-view
        :key="$route.fullpath"
        class="body"
        :language="language"
      ></router-view>
    </keep-alive>
    <Foot v-if="hidefoot" :language="language" :menu="menu"></Foot>
    <div class="side_div">
      <el-popover
        placement="left"
        width="180"
        trigger="hover"
        transition="none"
        close-delay="0"
      >
        <p :style="{color:'#024580',margin:0,textAlign:'center'}">{{ floatList[0].tel }}</p>
        <div class="side_img_div1" slot="reference">
          <img src="../../static/img/new_phone_icon.png"/>
        </div>
      </el-popover>
      <el-popover
        placement="left"
        width="150"
        trigger="hover"
        transition="none"
        close-delay="0"
      >
        <img :src="floatList[0].wechat" class="img_div2">
        <div class="side_img_div" slot="reference">
          <img src="../../static/img/new_wechat_icon.png"/>
        </div>
      </el-popover>

      <el-popover
        placement="left"
        width="150"
        transition="none"
        close-delay="0"
        trigger="hover">
        <p :style="{color:'#024580',margin:0,textAlign:'center'}">whatsapp</p>
        <div class="side_img_div" slot="reference"
             @click="jumpTo('https://api.whatsapp.com/send?phone='+floatList[0].whatsapp)">
          <img src="../../static/img/new_whatsapp_icon.png"/>
        </div>
      </el-popover>
      <el-popover
        placement="left"
        transition="none"
        close-delay="0"
        :width="language == 'zh' ? '150':'200'"
        trigger="hover">
        <p :style="{color:'#024580',margin:0,textAlign:'center'}">
          {{ language == 'zh' ? '在线询价' : 'Request for quotation' }}</p>
        <div class="side_img_div" slot="reference" @click="showInfoDialog">
          <img src="../../static/img/new_customer_icon.png"/>
        </div>
      </el-popover>
      <el-popover
        placement="left"
        width="220"
        close-delay="0"
        transition="none"
        trigger="hover"
      >
        <p :style="{color:'#024580',margin:0}">{{ floatList[0].email }}</p>
        <div class="side_img_div" slot="reference" @click="sendEmail(floatList[0].email)">
          <img src="../../static/img/new_email_icon.png"/>
        </div>
      </el-popover>

      <div class="side_img_div2" @click="goTopback">
        <img src="../../static/img/new_back_top_icon.png"/>
      </div>
    </div>
    <AskDialog ref="AskDialog" :language="language"></AskDialog>
  </div>
</template>

<script>
import Foot from "../components/Foot";
import AskDialog from "./AskDialog.vue";

export default {
  components: {
    AskDialog,
    Foot,
  },
  name: "App",
  data() {
    return {
      hidefoot: true, //公司简介隐藏底部
      fouce: true,
      languagehover: false,
      hideHeader: true,
      hideSearch: true,
      LogoImg: "",
      WxGZHImg: "",
      language: "",
      mainurl: "",
      input: "",
      footer: [],
      activeIndex: "1",
      qrcodeheight: 0,
      menushow1: false,
      menushow2: false,
      menushow3: false,
      menushow4: false,
      menushow5: false,
      menu: [],
      icon_logo: require("../../static/img/资源 1.png"),
      icon_menu: require("../../static/img/汉堡栏.png"),
      icon_close: require("../../static/img/nav_close.png"),
      jszc: [],
      xwdt: [],
      lxwm: [],
      floatList: [],
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.hidefoot = this.$route.path.indexOf("Aboutus") <= 0;
      this.hideSearch = this.$route.path.indexOf("Product") < 0;
      // this.$parent.hideSearch = from.fullPath.indexOf('Product') >= 0?true:false
      console.log("HHH navto=" + this.hideSearch);
      // if (this.GetQueryString("language=en")) {
      //   this.language='en';
      //   localStorage.setItem("language", this.language);
      // }
      this.language = localStorage.getItem("language") || "zh";
      console.log('watch index language==' + this.language)
      this.getInfo();
    },
  },
  mounted: function () {
    this.hidefoot = this.$route.path.indexOf("Aboutus") <= 0;
    this.hideSearch = this.$route.path.indexOf("Product") < 0;
    if (this.GetQueryString("language")) {
      if (this.GetQueryString("language") == 'en') {
        this.language = 'en';
      } else {
        this.language = 'zh';
      }
      localStorage.setItem("language", this.language);
    }
    this.language = localStorage.getItem("language") || "zh";
    console.log('index language==' + this.language)
    document.title = this.language == 'zh' ? this.$route.meta.title : this.$route.meta.titleEn;
    this.getInfo();
    this.getMenu();
    this.getFloatMsg();
  },
  methods: {
    sendEmail(email) {
      let mailto_link = 'mailto:' + email;
      window.location.href = mailto_link;
    },
    showInfoDialog() {
      this.$refs.AskDialog.init();
    },
    goTopback() {
      window.scrollTo(0, 0);
    },
    getFloatMsg() {
      this.$http.get("hdbs/api/floatmsg/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.floatList = response.data.page.list;
          }
        }.bind(this)
      );
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    showMenu(position) {
      this.menushow1 = false;
      this.menushow2 = false;
      this.menushow3 = false;
      this.menushow4 = false;
      this.menushow5 = false;
      if (position == 1) {
        this.menushow1 = true;
      } else if (position == 2) {
        this.menushow2 = true;
      } else if (position == 3) {
        this.menushow3 = true;
      } else if (position == 4) {
        this.menushow4 = true;
      } else if (position == 5) {
        this.menushow5 = true;
      }
    },
    handlelanguage(language) {
      this.language = language;
      localStorage.setItem("language", language);
      // this.$router.go(0)
      document.title = this.language == 'zh' ? this.$route.meta.title : this.$route.meta.titleEn;
    },
    getInfo() {
      this.$http.get("/hdbs/api/product/type/tree", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.menu = response.data.data;
            this.menu.map((r) => {
              r.level = 1;
              if (!r.children && r.num == 0) {
                r.disabled = true;
                return false;
              }
              if (r.children) {
                r.children.map((c) => {
                  c.level = 2;
                  if (c.num == 0) {
                    c.disabled = true;
                    if (c.children) {
                      c.children.map((a) => {
                        a.level = 3;
                        a.disabled = true;
                      });
                    }
                  } else {
                    if (c.children) {
                      c.children.map((a) => {
                        a.level = 3;
                        a.type1 = r.value;
                        if (a.num == 0) {
                          a.disabled = true;
                        }
                      });
                    }
                  }
                });
              }
            });
            console.log(this.menu);
          }
        }.bind(this)
      );
    },
    getMenu() {
      this.$http
        .get("/hdbs/api/activity/type/list", {
          params: {
            parentType: "技术支持",
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.jszc = response.data.data.filter((x) => {
                return (
                  x.parentType == "技术支持" || x.parentType == "技术支持说明"
                );
              });
              this.xwdt = response.data.data.filter((x) => {
                return x.parentType == "新闻动态";
              });
              this.lxwm = response.data.data.filter((x) => {
                return x.parentType == "联系我们";
              });
            }
          }.bind(this)
        );
    },
    changefoot(foot) {
      this.hidefoot = footf;
    },
    searchEnterFun() {
      console.log(this.input);
      sessionStorage.setItem("input", this.input);
      this.navto("/Case");
    },
    focusinput(num) {
      if (num == 0) {
        this.fouce = false;
        this.$nextTick(() => {
          this.$refs.elinput.focus();
        });
      } else {
        this.fouce = true;
      }
    },
    navtoLazy(path) {
      let that = this;
      this.menushow1 = false;
      this.$refs.empPopover.doClose()//关闭
      setTimeout(function () {
        that.$router.push(path);
      }, 200)
    },
    navto(path) {
      this.menushow1 = false;
      this.$router.push(path);
    },
    navtoWithType(path, type, position) {
      localStorage.setItem(type, position);
      this.$router.push(path + "?type=" + position);
    },
    jumpTo(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style>
.el-popover {
  z-index: 111 !important;
  background: #fffffff2;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
</style>
<style lang="stylus" scoped>
.phone_a {
  font-size: 17px;
  padding: 0.5em 5% !important;
}

.body {
  padding-top: calc(65px + 6vh);
}

.pc_nav {
  display: block;
}

.phone_nav {
  display: none;
}

.footbox {
  display: flex;

  .foot-item {
    flex: 1;
  }
}

.line-shadow {
  width: 100%;
  height: 1px;
  box-shadow: inset 0px 3px 6px 1px rgba(0, 0, 0, 0.12);
}

/deep/ .el-popover {
  z-index: 111;
}

.el-popover .my-popover {
  z-index: 111;
  background: red;
}

.dropdown-div-show {
  visibility: visible;
  opacity: 1;
  //transition: all 0.5s;
}

.dropdown-div-hide {
  opacity: 0;
  visibility: hidden;
  //transition: all 0.2s;
}

.dropdown-div {
  .title {
    font-size: 1.7rem !important;
    font-family: Regular;
    color: var(--mainGary);
    cursor: pointer;
    text-align: center;
    padding: 1rem;
  }

  .title:hover {
    color: #024580;
    font-family: Demibold;
    cursor: pointer;
  }
}

.product-menu {
  padding: 0;
  position: absolute;
  display: block;
  width: 90%;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 111;
  background: #fffffff2;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  top: 50px;
  // top:calc( 5.5vw);
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  text-transform: none !important;

  .top-row-center {
    display: flex;
    justify-content: center;
  }

  .top-row {
    display: flex;
    width: 100%;
    text-align: center;
    font-size: 1.7rem;
    font-family: Regular;
    color: var(--mainGary);
    padding: 40px 0 20px 0;
    flex-wrap: wrap;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.12);

    .top-item {
      flex: 1;
      width: calc(((100% - 0px) / 6));
      min-width: calc(((100% - 0px) / 6));
      max-width: calc(((100% - 0px) / 6));
      margin-bottom: 40px;

      .title:hover {
        color: #024580;
        font-family: Demibold;
        cursor: pointer;
      }

      .heng {
        height: 1px;
        width: 100px;
        background: var(--mainGary);
        display: inline-flex;
        text-align: center;
      }

      .child {
        padding-top: 10px;
      }

      .child-title {
        color: #727171;
      }

      .child-title:hover {
        cursor: pointer;
        color: #024580;
        font-family: Demibold;
      }

      .child-title-disabled {
        font-family: Regular;
        color: #72717180 !important;
        cursor: not-allowed;
      }

      .child-title-disabled:hover {
        font-family: Regular;
        color: #72717180 !important;
        cursor: not-allowed;
      }

      .title-disabled {
        font-family: Regular;
        color: #72717180 !important;
        cursor: not-allowed;
      }

      .title-disabled:hover {
        font-family: Regular;
        color: #72717180 !important;
        cursor: not-allowed;
      }
    }
  }
}

.product-menu-show {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}

.product-menu-hide {
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
}

.side_div {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: fixed;
  right: 2rem;
  // left:92vw;
  bottom: 30%;
  z-index: 9999;
  border-radius: 4px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);

  .side_img_div {
    cursor: pointer;

    &:hover {
      background: #EDEEF6;
    }
  }

  .side_img_div1 {
    cursor: pointer;

    &:hover {
      background: #EDEEF6;
    }

    &:first-child {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }

  .side_img_div2 {
    cursor: pointer;

    &:hover {
      background: #EDEEF6;
    }

    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  img {
    width: 2rem;
    height: auto;
    margin: 2rem 2rem;
  }
}

@media screen and (max-width: 1200px) {
  .pc_nav {
    display: none;
  }

  .phone_nav {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue